import script from "./CardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CardComponent.vue?vue&type=script&setup=true&lang=js"

import "./CardComponent.vue?vue&type=style&index=0&id=25d01224&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d01224"]])

export default __exports__